
import Vue from 'vue'
import BayOnDeck from '@/view/pages/vesselProfile/components/HatchCovers/BayOnDeckHatchCovers.vue'
import BayUnderDeck from '@/view/pages/vesselProfile/components/BayUnderDeck.vue'
import { mapGetters, mapActions, mapState } from 'vuex'
import NameGenerator from '../view/pages/vesselProfile/NameGenerator';
import { ceil } from 'lodash';
//import {VesselProfileHatch} from '@/types/vesselProfile';

interface Container {
  id: string,
  x: number,
  y: number,
  width: number,
  height: number,
  fill: string,
  stroke: string,
  strokeWidth: number,
  type: string
}
const nameGenerator = new NameGenerator();
export default Vue.extend({
  props: {
    cellSize: {
      type: Number,
      default: 0
    },
    cellsCount: {
      type: Number,
      default: 0
    },
    vesselProfileHatchCovers: {
      type: Object,
      required: true,
    },
    CoverColor: {
      type: String,
      default: "black"

    }
  },
  data() {
    return {
      ctrlKey: false,
      rows: 1,
      cells: [],
      //cellSize: 5,
      isSelecting: false,
      startCell: null,
      endCell: null,
      nameIndex: 0
    }
  },
  components: {
    BayOnDeck,
    BayUnderDeck,

  },
  methods: {
    ...mapActions({
      setSelectedHatchData: 'setSelectedHatchData'
    }),
    initCells() {
      // Generate grid cells  
      var cellsCount = this.cellsCount;
      let id = 0;
      for (let row = 0; row < this.rows; row++) {
        for (let col = 0; col < cellsCount; col++) {
          this.cells.push({
            id: id++,
            x: col * this.cellSize + 0.6,
            y: row * this.cellSize,
            width: this.cellSize,
            height: this.cellSize,
            fill: "white",
            stroke: "gray",
            strokeWidth: 1,
          });
        }
      }
      //this.updateCells()
    },
    onMouseOver(cell) {
      if (cell.isGap) {
        document.body.style.cursor = 'not-allowed'
      }
      else {
        document.body.style.cursor = 'default'
      }
    },
    onMouseDown(cell) {
      if (cell.isGap) return
      this.isSelecting = true;
      this.startCell = cell;
      this.endCell = null;
    },
    onMouseUp(cell) {
      if (cell.isGap) return

      if (!this.isSelecting) return;
      if (this.startCell.id == cell.id) return;
      this.isSelecting = false;
      this.endCell = cell;

      if (this.startCell && this.endCell) {
        let start = this.startCell.id;
        let end = this.endCell.id;

        // اصلاح ترتیب در صورت انتخاب معکوس
        if (start > end) {
          [start, end] = [end, start]; // جابه‌جایی مقادیر
        }

        const newSelection = { start, end };
        if (!this.hasOverlap(newSelection)) {

          // Update colors for selected range
          this.nameIndex++;
          this.setSelectedHatchData({
            vesselProfileHatchCovers: ({
              coverName: nameGenerator.getNextName(),
              startCell: start,
              endCell: end
            })
          })
          this.updateCells()

          //this.updateCellColors();
          //textArray.shift();
        }
        else {
          alert("Overlap detected! Selection not added.");
        }
      }
    },
    hasOverlap(newSelection: { start: number, end: number }): boolean {
      return this.vesselProfileHatchCovers.some(cell => !(cell.endCell < newSelection.start || newSelection.end < cell.startCell));
    },
    onmouseout(cell) {
      //alert("")
     

    },
    onmouseenter(cell) {
  
    },
    updateCellColors() {
      if (!this.startCell || !this.endCell) return;

      // Determine the range of cells to color
      const startX = Math.min(this.startCell.x, this.endCell.x);


      const endX = Math.max(this.startCell.x, this.endCell.x);
      this.cells.forEach((cell) => {
        if (
          cell.x >= startX &&
          cell.x <= endX
        ) {
          cell.fill = this.CoverColor; // Highlight selected cells
        }
        if (cell.x > endX && cell.x <= endX + this.cellSize)
          cell.fill = "white";
      });
    },
    updateCells() {
      this.vesselProfileHatchCovers?.forEach(data => {
        this.cells.forEach((cell) => {
      
          if (cell.id >= data.startCell && cell.id <= data.endCell) {
            cell.fill = this.CoverColor; 
            cell.f = true
          }
          if (cell.id == data.endCell + 1) {
            cell.isGap = true
          }
        })
      });
    },
    ResetCells(cover) {
      this.cells.forEach((cell) => {

        if (cell.id >= cover.startCell && cell.id <= cover.endCell) {
          cell.fill = "white";
        }
        if (cell.id == cover.endCell + 1 || cell.id == cover.startCell - 1) {
         
          cell.isGap = false
        }
      })
    }
  },
  computed: {

    Cells() {
      this.cells.forEach((cell) => {
        cell.fill = "white"
      });
      this.vesselProfileHatchCovers?.map(data => {
        this.cells.forEach((cell) => {
          /*  if (cell.id == data.startCell) {
             cell.fill = "white"
           } */
          if (cell.id >= data.startCell && cell.id <= data.endCell) {
            cell.fill = this.CoverColor; // Highlight selected cells
          }
          if (cell.id == data.endCell + 1 || cell.id == data.startCell - 1) {
            cell.isGap = true
          }
        })
      });
      return this.cells;
    },
    ...mapGetters({
      selectedHatchIndex: 'getSelectedHatchIndex'
    }),

    ...mapState(['vesselProfile']),
    configKonvaCovers() {
      return {
        width: this.cellsCount * this.cellSize + 1,
        height: this.cellsCount + 10
      }
    }
  },
  created() {
    console.log(this.vesselProfileHatchCovers)
    document.addEventListener('keydown', this.onKeyPress);
    document.addEventListener('keyup', this.onkeyup);
    document.addEventListener('mouseover', this.onMouseOver);
    document.addEventListener('mouseout', this.onmouseout);
    document.addEventListener('mouseenter', this.onmouseenter);
    this.initCells()
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyPress);
    document.removeEventListener('keyup', this.onkeyup);
    document.removeEventListener('mouseover', this.onMouseOver);
    document.removeEventListener('mouseout', this.onmouseout);
    document.removeEventListener('mouseenter', this.onmouseenter);

  },
  watch: {
    vesselProfileHatchCovers: {
    handler(newValue, oldValue) {
        // ریست کامل تمام سلول‌ها
        this.cells.forEach(cell => {
        cell.fill = 'white';
        cell.isGap = false;
      });

      // مقداردهی مجدد سلول‌ها طبق داده‌های جدید
      this.updateCells();
    },
    deep: true,
    immediate: true 
  }
  }
})
